/**
 * Do not edit directly
 * Generated on Tue, 05 Aug 2025 14:28:15 GMT
 */

export const CanvasDefaultInv = "#F7F8F8";
export const CanvasDefault = "#0E1113";
export const Neutral0 = "#ffffff";
export const Neutral100 = "#F7F8F8";
export const Neutral200 = "#F0F1F2";
export const Neutral300 = "#E1E3E4";
export const Neutral400 = "#B4BABD";
export const Neutral500 = "#899296";
export const Neutral600 = "#646F75";
export const Neutral700 = "#41484D";
export const Neutral800 = "#2B3134";
export const Neutral900 = "#191C1E";
export const Neutral1000 = "#0E1113";
export const NeutralBgDefault = "#191C1E";
export const NeutralBgInvDefault = "#ffffff";
export const NeutralBgHover = "#2B3134";
export const NeutralBgActive = "#41484D";
export const NeutralBgDisabled = "#41484D";
export const NeutralBgWeakDefault = "#2B3134";
export const NeutralBgWeakHover = "#41484D";
export const NeutralBgWeakActive = "#646F75";
export const NeutralBgWeakDisabled = "#41484D";
export const NeutralTxtDefault = "#E1E3E4";
export const NeutralTxtHover = "#F0F1F2";
export const NeutralTxtActive = "#F7F8F8";
export const NeutralTxtDisabled = "#41484D";
export const NeutralTxtWeakDefault = "#B4BABD";
export const NeutralTxtWeakHover = "#E1E3E4";
export const NeutralTxtWeakActive = "#F0F1F2";
export const NeutralTxtWeakDisabled = "#41484D";
export const NeutralTxtStrongDefault = "#ffffff";
export const NeutralTxtStrongHover = "#E1E3E4";
export const NeutralTxtStrongActive = "#ffffff";
export const NeutralTxtStrongDisabled = "#41484D";
export const NeutralTxtInvDefault = "#191C1E";
export const NeutralTxtInvHover = "#646F75";
export const NeutralTxtInvActive = "#2B3134";
export const NeutralTxtInvDisabled = "#2B3134";
export const NeutralTxtWeakInvDefault = "#B4BABD";
export const NeutralTxtWeakInvHover = "#E1E3E4";
export const NeutralTxtWeakInvActive = "#F0F1F2";
export const NeutralTxtWeakInvDisabled = "#2B3134";
export const NeutralTxtStrongInvDefault = "#0E1113";
export const NeutralTxtStrongInvHover = "#2B3134";
export const NeutralTxtStrongInvActive = "#0E1113";
export const NeutralTxtStrongInvDisabled = "#2B3134";
export const NeutralIconDefault = "#E1E3E4";
export const NeutralIconHover = "#F0F1F2";
export const NeutralIconActive = "#F7F8F8";
export const NeutralIconDisabled = "#41484D";
export const NeutralIconWeakDefault = "#B4BABD";
export const NeutralIconWeakHover = "#E1E3E4";
export const NeutralIconWeakActive = "#F0F1F2";
export const NeutralIconWeakDisabled = "#41484D";
export const NeutralIconStrongDefault = "#ffffff";
export const NeutralIconStrongHover = "#E1E3E4";
export const NeutralIconStrongActive = "#ffffff";
export const NeutralIconStrongDisabled = "#41484D";
export const NeutralIconInvDefault = "#191C1E";
export const NeutralIconInvHover = "#2B3134";
export const NeutralIconInvActive = "#41484D";
export const NeutralIconInvDisabled = "#2B3134";
export const NeutralIconWeakInvDefault = "#B4BABD";
export const NeutralIconWeakInvHover = "#E1E3E4";
export const NeutralIconWeakInvActive = "#F0F1F2";
export const NeutralIconWeakInvDisabled = "#2B3134";
export const NeutralIconStrongInvDefault = "#0E1113";
export const NeutralIconStrongInvHover = "#2B3134";
export const NeutralIconStrongInvActive = "#0E1113";
export const NeutralIconStrongInvDisabled = "#2B3134";
export const NeutralBorderDefault = "#646F75";
export const NeutralBorderHover = "#899296";
export const NeutralBorderActive = "#B4BABD";
export const NeutralBorderDisabled = "#41484D";
export const NeutralBorderWeakDefault = "#646f7580";
export const NeutralBorderWeakHover = "#89929680";
export const NeutralBorderWeakActive = "#b4babd80";
export const NeutralBorderWeakDisabled = "#41484d80";
export const NeutralBorderStrongDefault = "#ffffff";
export const NeutralBorderStrongHover = "#E1E3E4";
export const NeutralBorderStrongActive = "#ffffff";
export const NeutralBorderStrongDisabled = "#41484D";
export const PrimaryBgDefault = "#6046FF";
export const PrimaryBgHover = "#806BFF";
export const PrimaryBgActive = "#A090FF";
export const PrimaryBgDisabled = "#3A2A99";
export const PrimaryBgWeakDefault = "#4D38CC";
export const PrimaryBgWeakHover = "#6046FF";
export const PrimaryBgWeakActive = "#A090FF";
export const PrimaryBgWeakDisabled = "#3A2A99";
export const PrimaryTxtDefault = "#BFB5FF";
export const PrimaryTxtHover = "#DFDAFF";
export const PrimaryTxtActive = "#EFEDFF";
export const PrimaryTxtDisabled = "#3A2A99";
export const PrimaryTxtWeakDefault = "#A090FF";
export const PrimaryTxtWeakHover = "#BFB5FF";
export const PrimaryTxtWeakActive = "#DFDAFF";
export const PrimaryTxtWeakDisabled = "#3A2A99";
export const PrimaryTxtInvDefault = "#EFEDFF";
export const PrimaryTxtInvHover = "#ffffff";
export const PrimaryTxtInvActive = "#261C66";
export const PrimaryTxtInvDisabled = "#A090FF";
export const PrimaryTxtWeakInvDefault = "#DFDAFF";
export const PrimaryTxtWeakInvHover = "#EFEDFF";
export const PrimaryTxtWeakInvActive = "#130E33";
export const PrimaryTxtWeakInvDisabled = "#A090FF";
export const PrimaryIconDefault = "#BFB5FF";
export const PrimaryIconHover = "#DFDAFF";
export const PrimaryIconActive = "#EFEDFF";
export const PrimaryIconDisabled = "#3A2A99";
export const PrimaryIconWeakDefault = "#BFB5FF";
export const PrimaryIconWeakHover = "#DFDAFF";
export const PrimaryIconWeakActive = "#EFEDFF";
export const PrimaryIconWeakDisabled = "#3A2A99";
export const PrimaryIconInvDefault = "#EFEDFF";
export const PrimaryIconInvHover = "#ffffff";
export const PrimaryIconInvActive = "#261C66";
export const PrimaryIconInvDisabled = "#A090FF";
export const PrimaryIconWeakInvDefault = "#DFDAFF";
export const PrimaryIconWeakInvHover = "#EFEDFF";
export const PrimaryIconWeakInvActive = "#130E33";
export const PrimaryIconWeakInvDisabled = "#A090FF";
export const PrimaryBorderDefault = "#6046FF";
export const PrimaryBorderHover = "#A090FF";
export const PrimaryBorderActive = "#A090FF";
export const PrimaryBorderDisabled = "#3A2A99";
export const PrimaryBorderWeakDefault = "#5f46ff80";
export const PrimaryBorderWeakHover = "#a090ff80";
export const PrimaryBorderWeakActive = "#a090ff80";
export const PrimaryBorderWeakDisabled = "#3b2a9980";
export const SuccessBgDefault = "#289B3F";
export const SuccessBgHover = "#8FC693";
export const SuccessBgActive = "#D2E8D3";
export const SuccessBgDisabled = "#093912";
export const SuccessTxtDefault = "#289B3F";
export const SuccessTxtHover = "#8FC693";
export const SuccessTxtActive = "#D2E8D3";
export const SuccessTxtDisabled = "#093912";
export const SuccessTxtInvDefault = "#021504";
export const SuccessTxtInvHover = "#021504";
export const SuccessTxtInvActive = "#021504";
export const SuccessTxtInvDisabled = "#022105";
export const SuccessIconDefault = "#289B3F";
export const SuccessIconHover = "#8FC693";
export const SuccessIconActive = "#D2E8D3";
export const SuccessIconDisabled = "#093912";
export const SuccessIconInvDefault = "#021504";
export const SuccessIconInvHover = "#021504";
export const SuccessIconInvActive = "#021504";
export const SuccessIconInvDisabled = "#022105";
export const SuccessBorderDefault = "#289B3F";
export const SuccessBorderHover = "#8FC693";
export const SuccessBorderActive = "#D2E8D3";
export const SuccessBorderDisabled = "#093912";
export const CriticalBgDefault = "#FB3728";
export const CriticalBgHover = "#FDA091";
export const CriticalBgActive = "#FFDAD3";
export const CriticalBgDisabled = "#630E08";
export const CriticalTxtDefault = "#FB3728";
export const CriticalTxtHover = "#FDA091";
export const CriticalTxtActive = "#FFDAD3";
export const CriticalTxtDisabled = "#630E08";
export const CriticalTxtInvDefault = "#290302";
export const CriticalTxtInvHover = "#3E0502";
export const CriticalTxtInvActive = "#630E08";
export const CriticalTxtInvDisabled = "#3E0502";
export const CriticalIconDefault = "#FB3728";
export const CriticalIconHover = "#FDA091";
export const CriticalIconActive = "#FFDAD3";
export const CriticalIconDisabled = "#630E08";
export const CriticalIconInvDefault = "#290302";
export const CriticalIconInvHover = "#3E0502";
export const CriticalIconInvActive = "#630E08";
export const CriticalIconInvDisabled = "#3E0502";
export const CriticalBorderDefault = "#FB3728";
export const CriticalBorderHover = "#FDA091";
export const CriticalBorderActive = "#FFDAD3";
export const CriticalBorderDisabled = "#630E08";
export const HighlightStrongBgStrong = "#D5F800";
export const HighlightStrongBgWeak = "#809500";
export const HighlightStrongOnBgStrong = "#2B3200";
export const HighlightStrongOnBgWeak = "#ffffff";
export const HighlightStrongBorderStrong = "#D5F800";
export const HighlightStrongBorderWeak = "#809500";
export const HighlightWeakBgStrong = "#6046FF";
export const HighlightWeakBgWeak = "#3A2A99";
export const HighlightWeakOnBgStrong = "#ffffff";
export const HighlightWeakOnBgWeak = "#ffffff";
export const HighlightWeakBorderStrong = "#6046FF";
export const HighlightWeakBorderWeak = "#3A2A99";
export const HighlightVioletBgStrong = "#6046FF";
export const HighlightVioletBgWeak = "#3A2A99";
export const HighlightVioletOnBgStrong = "#ffffff";
export const HighlightVioletOnBgWeak = "#ffffff";
export const HighlightVioletBorderStrong = "#6046FF";
export const HighlightVioletBorderWeak = "#3A2A99";
export const HighlightLimeBgStrong = "#D5F800";
export const HighlightLimeBgWeak = "#809500";
export const HighlightLimeOnBgStrong = "#2B3200";
export const HighlightLimeOnBgWeak = "#ffffff";
export const HighlightLimeBorderStrong = "#D5F800";
export const HighlightLimeBorderWeak = "#809500";
export const HighlightOrangeBgStrong = "#FF4A11";
export const HighlightOrangeBgWeak = "#992C0A";
export const HighlightOrangeOnBgStrong = "#330F03";
export const HighlightOrangeOnBgWeak = "#ffffff";
export const HighlightOrangeBorderStrong = "#FF4A11";
export const HighlightOrangeBorderWeak = "#992C0A";
export const HighlightSkyblueBgStrong = "#00D0EC";
export const HighlightSkyblueBgWeak = "#007D8E";
export const HighlightSkyblueOnBgStrong = "#002A2F";
export const HighlightSkyblueOnBgWeak = "#ffffff";
export const HighlightSkyblueBorderStrong = "#00D0EC";
export const HighlightSkyblueBorderWeak = "#007D8E";
export const HighlightPinkBgStrong = "#E81CEC";
export const HighlightPinkBgWeak = "#8B118E";
export const HighlightPinkOnBgStrong = "#2E062F";
export const HighlightPinkOnBgWeak = "#ffffff";
export const HighlightPinkBorderStrong = "#E81CEC";
export const HighlightPinkBorderWeak = "#8B118E";
export const Violet0 = "#ffffff";
export const Violet100 = "#EFEDFF";
export const Violet200 = "#DFDAFF";
export const Violet300 = "#BFB5FF";
export const Violet400 = "#A090FF";
export const Violet500 = "#806BFF";
export const Violet600 = "#6046FF";
export const Violet700 = "#4D38CC";
export const Violet800 = "#3A2A99";
export const Violet900 = "#261C66";
export const Violet1000 = "#130E33";
export const Lime0 = "#ffffff";
export const Lime100 = "#FBFEE6";
export const Lime200 = "#F7FECC";
export const Lime300 = "#EEFC99";
export const Lime400 = "#E6FB66";
export const Lime500 = "#DDF933";
export const Lime600 = "#D5F800";
export const Lime700 = "#AAC600";
export const Lime800 = "#809500";
export const Lime900 = "#556300";
export const Lime1000 = "#2B3200";
export const Orange0 = "#ffffff";
export const Orange100 = "#FFEDE7";
export const Orange200 = "#FFDBCF";
export const Orange300 = "#FFB7A0";
export const Orange400 = "#FF9270";
export const Orange500 = "#FF6E41";
export const Orange600 = "#FF4A11";
export const Orange700 = "#CC3B0E";
export const Orange800 = "#992C0A";
export const Orange900 = "#661E07";
export const Orange1000 = "#330F03";
export const Pink0 = "#ffffff";
export const Pink100 = "#FDE8FD";
export const Pink200 = "#FAD2FB";
export const Pink300 = "#F6A4F7";
export const Pink400 = "#F177F4";
export const Pink500 = "#ED49F0";
export const Pink600 = "#E81CEC";
export const Pink700 = "#BA16BD";
export const Pink800 = "#8B118E";
export const Pink900 = "#5D0B5E";
export const Pink1000 = "#2E062F";
export const Skyblue0 = "#ffffff";
export const Skyblue100 = "#E6FAFD";
export const Skyblue200 = "#CCF6FB";
export const Skyblue300 = "#99ECF7";
export const Skyblue400 = "#66E3F4";
export const Skyblue500 = "#33D9F0";
export const Skyblue600 = "#00D0EC";
export const Skyblue700 = "#00A6BD";
export const Skyblue800 = "#007D8E";
export const Skyblue900 = "#00535E";
export const Skyblue1000 = "#002A2F";
export const Green0 = "#ffffff";
export const Green100 = "#F3F9F3";
export const Green200 = "#E7F4E8";
export const Green300 = "#D2E8D3";
export const Green400 = "#8FC693";
export const Green500 = "#289B3F";
export const Green600 = "#1C7B30";
export const Green700 = "#11521E";
export const Green800 = "#093912";
export const Green900 = "#022105";
export const Green1000 = "#021504";
export const Red0 = "#ffffff";
export const Red100 = "#FFF6F4";
export const Red200 = "#FDEDEA";
export const Red300 = "#FFDAD3";
export const Red400 = "#FDA091";
export const Red500 = "#FB3728";
export const Red600 = "#CC2A1E";
export const Red700 = "#8C1810";
export const Red800 = "#630E08";
export const Red900 = "#3E0502";
export const Red1000 = "#290302";
